import { COOKIES, getCookieValue } from '@/utils/cookies';
import type { RequestInterceptor } from '../../types';

export const credentialsInterceptor: RequestInterceptor = async (ctx, next) => {
    const finalInit: RequestInit = {
        ...ctx.init
    };

    const skipCredentials = ctx.options?.excludeCredentials === true;

    if (typeof window === 'undefined' && !skipCredentials) {
        const authToken = await getCookieValue(COOKIES.AUTH_TOKEN);
        const loginToken = await getCookieValue(COOKIES.LOGIN_TOKEN);
        if (authToken && loginToken) {
            finalInit.headers = {
                ...ctx.init?.headers,
                'X-Auth-Token': authToken,
                'X-Login-Token': loginToken
            };
        }
    }

    if (typeof window !== 'undefined' && !ctx.init?.credentials && !skipCredentials) {
        finalInit.credentials = 'include';
    }

    return next({
        input: ctx.input,
        init: finalInit,
        options: ctx.options
    });
};
